import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import RadioButton from '../RadioButton';
import ideal from '../PaymentMethodButton/icons/ideal-wero.svg';
import paypal from '../PaymentMethodButton/icons/paypal.svg';
import creditcard from '../PaymentMethodButton/icons/creditcard.svg';
import directDebit from '../PaymentMethodButton/icons/directDebit.png';
import manualTransfer from '../PaymentMethodButton/icons/manualTransfer.svg';

const logos = {
  ideal,
  payPal: paypal,
  creditCard: creditcard,
  directDebit,
  manualTransfer
};

const Row = styled.div`
  border-bottom: 1px solid ${props => props.theme.paymentMethodsContainer.dividerColor};

  && label {
    padding: ${props => props.theme.paymentMethodsContainer.rowPadding || '24px 0 24px 30px'};
    color: ${props => props.theme.paymentMethodsContainer.labelColor};
    font-size: ${props => props.theme.paymentMethodsContainer.labelFontSize};
    font-weight: ${props => props.theme.paymentMethodsContainer.labelFontWeight || '400'};
    line-height: ${props => props.theme.paymentMethodsContainer.labelLineHeight};
  }
`;

const Logo = styled.img`
  flex: 0 0 auto;
  height: ${props => props.theme.paymentMethodsContainer.logoHeight || '24px'};
  width: auto;
  margin-left: 16px;
`;

export default function PaymentMethodListItem(props) {
  const logo = logos[props.value];

  return (
    <Row>
      <RadioButton
        fullWidth
        name={props.name}
        value={props.value}
        label={props.label}
        isChecked={props.isChecked}
        setValue={props.setValue}
        validate={props.validate}>
        {logo ? <Logo src={logo} alt={props.label} /> : null}
      </RadioButton>
    </Row>
  );
}

PaymentMethodListItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string,
  isChecked: PropTypes.bool,
  setValue: PropTypes.func,
  validate: PropTypes.func
};
